import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import type { NavItem } from '@/types';
import { cn } from '@/utils/helpers';

interface HeaderNavProps {
  items: NavItem[];
}

export function HeaderNav({ items }: HeaderNavProps) {
  return (
    <nav className="hidden lg:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" aria-label="Main navigation">
      <ul className="flex items-center gap-1">
        {items.map((item) => (
          <NavMenuItem key={item.label} item={item} />
        ))}
      </ul>
    </nav>
  );
}

function NavMenuItem({ item }: { item: NavItem }) {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = item.children && item.children.length > 0;

  return (
    <li
      className="relative"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <Link
        to={item.href}
        className={cn(
          'flex items-center gap-1 rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wider text-zinc-900/80 transition-colors hover:bg-black/5 hover:text-zinc-900',
        )}
      >
        {item.label}
        {hasChildren && <ChevronDown className="h-3.5 w-3.5" />}
      </Link>

      {hasChildren && isOpen && (
        <div className="absolute top-full left-0 z-50 min-w-48 pt-1">
          <div className="rounded-2xl border border-black/10 bg-white/95 py-2 shadow-2xl backdrop-blur-md">
            {item.children?.map((child) => (
              <Link
                key={child.label}
                to={child.href}
                className="block px-5 py-2 text-xs font-semibold uppercase tracking-wider text-zinc-900/70 transition-colors hover:bg-black/5 hover:text-zinc-900"
              >
                {child.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </li>
  );
}
